<template>
  <div id="lineCharts">

  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'lineCharts',
  props: ['lineData'],
  data () {
    return {
      lineType: false,
      data1: [0, 132, 60, 334, 80, 160, 0], //400地级市折线图数据
      data2: [0, 20, 82, 30, 20, 40, 0], //2000区县数据
      option: null,
      myChart: null
    }
  },
  methods: {
    changeCity () {
      setInterval(() => {
        this.lineType = !this.lineType
        //更新视图
        this.myChart.setOption({ series: [{ data: this.lineType ? this.data1 : this.data2 }] }, {
          notMerge: false,  //是否开启合并模式，false默认为合并
          lazyUpdate: false //是否立即更新，false默认为立即更新
        });
        this.$emit('changeLineType')
      }, 3500)

    },
  },
  mounted () {

    this.myChart = echarts.init(document.getElementById('lineCharts'));

    this.option = {
      color: ['#08d1e7', '#08d1e7'],
      title: {

      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: false
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          show: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        }
      ],
      yAxis: [
        {
          type: 'value',
          show: false
        }
      ],
      series: [
        {
          name: 'Line 3',
          type: 'line',
          stack: 'Total',
          smooth: true,
          showSymbol: false,
          areaStyle: {
            opacity: 0.6,

            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgb(0,178,205)'
              },
              {
                offset: 1,

                color: 'rgb(0,42,115)'
              }
            ])
          },
          select: {
            disabled: true,
          },
          emphasis: {
            focus: 'series'
          },
          data: this.data1
        },
      ]
    };
    this.myChart.setOption(this.option)
    this.changeCity()
  }
}
</script>

<style>
#lineCharts {
  top: 120px;
  left: 115px;
  position: absolute;
  width: 260px;
  height: 300px;
}
</style>